'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RetainSDK = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RETAIN_SDK_JS = '(function(i,s,o,g,r,a,m){i[\'ProfitWellObject\']=r;i[r]=i[r]||function(){\n  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);\n  })(window,document,\'script\',\'https://dna8twue3dlxq.cloudfront.net/js/profitwell.js\',\'profitwell\');';

var RetainSDK = exports.RetainSDK = function (_React$Component) {
  (0, _inherits3.default)(RetainSDK, _React$Component);

  function RetainSDK() {
    (0, _classCallCheck3.default)(this, RetainSDK);
    return (0, _possibleConstructorReturn3.default)(this, (RetainSDK.__proto__ || (0, _getPrototypeOf2.default)(RetainSDK)).apply(this, arguments));
  }

  (0, _createClass3.default)(RetainSDK, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.currentUser && !this.props.currentUser && this.isProfitwellLoaded()) {
        this.profitwell('user_email', nextProps.currentUser.email);
      }
      return false;
    }
  }, {
    key: 'isProfitwellLoaded',
    value: function isProfitwellLoaded() {
      return !!window.profitwell;
    }

    /* istanbul ignore next */

  }, {
    key: 'profitwell',
    value: function profitwell(type, data) {
      return window.profitwell(type, data);
    }
  }, {
    key: 'isRetainEnabled',
    value: function isRetainEnabled() {
      return !__LOCAL_DEV__ || __TEST__;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentUser = _props.currentUser,
          accountKey = _props.accountKey;


      if (!this.isRetainEnabled()) {
        return false;
      }

      var userSetJs = 'profitwell(\'auth_token\', \'' + accountKey + '\');';

      // Profitwell uses custom path params to allow non-logged in users to update their information
      // when coming from the Profitwell emails
      if (currentUser && currentUser.email) {
        userSetJs += 'profitwell(\'user_email\', ' + (0, _stringify2.default)(currentUser.email) + ');';
      }

      return _react2.default.createElement('script', {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: (RETAIN_SDK_JS + userSetJs).replace(/\n/g, '') }
      });
    }
  }]);
  return RetainSDK;
}(_react2.default.Component);

RetainSDK.propTypes = {
  currentUser: _propTypes2.default.object,
  accountKey: _propTypes2.default.string.isRequired
};